import React, {useContext, useEffect, useState, Fragment} from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import {BaseUrl} from "../../../../../contexts/baseUrl/baseUrl";
import Layout from "../../../../../components/sales/layout/layout";
import {Button} from "react-bootstrap";
import localization from "../../../../../assets/localization/localization";
import Images from "../../../../../assets/images/imageData";
import UcdCasesFilters from "../../../../../components/sales/ListFilters/UCDCasesFilter";
import ModalPop from "../../../../../components/sales/modal/modal";
import FormSection from "../../../../../components/sales/formSection/formSection";
import s from "../../../../../components/sales/paymentPortal/addPayment/addPayment.module.css";
import ConstantInput from "../../../../../components/sales/Input/constantInput/constantInput";
import DropDownInput from "../../../../../components/sales/Input/dropDownInput/dropDownInput";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";
import ListFilters from "components/sales/ListFilters/ListFilters";

const CaseListing = ({
                        match,
                         caseListRequest,
                         caseListResponse = [],
                         carBrandRequest,
                         carModelRequest,
                         carVariantRequest,
                         carBrandResponse = [],
                         carModelResponse = [],
                         carVariantResponse = [],
                         caseStatusUpdateResponse = [],
                         caseStatusUpdateRequest
                    }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [showFilter, setShowFilter] = useState(false);
    const [filterData, setFilterData] = useState(null);
    const [id, setId] = useState('');
    const [changeCarLoanStatusModalOpen, setChangeCarLoanStatusModalOpen] = useState(false)
    const [statusChangeInput, setStatusChangeInput] = useState({status:'', remark: '', id:''});
    const  [roleId, setRoleId] = useState();
    const [userId, setUserId] = useState()

    useEffect(() => {
        (async () => {
            let filter = '';
            // if(window.localStorage.apply_ucd_case_filter){
            //     filter = JSON.parse(window.localStorage.apply_ucd_case_filter)
            // }
            setRoleId(window.localStorage.getItem('fusion-role'));
            setUserId(JSON.parse(window.localStorage.loginDetails)?.id)
            setIsLoading(true)
            await caseListRequest(match?.params?.dealer_id, 1)
            await carBrandRequest()
            setIsLoading(false)
        })()
    }, [])

    const headers = [
        'Loan Application ID',
        'Business Name',
        'Customer First Name',
        'Loan Type',
        'Vehicle No',
        'Bank Name',
        'Required Loan Amount',
        'status',
        'Created At',
        'Created By',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await caseListRequest(match?.params?.dealer_id, val.selected + 1);
        setIsLoading(false);
    };

    const userProfile = localStorage.getItem('user_profile');

    if (userProfile) {
        const parsedUserProfile = JSON.parse(userProfile);
        const fusionUserId = parseInt(parsedUserProfile.id);
    }


    useEffect(() => {
        setListData([])
        if (caseListResponse && caseListResponse?.data  &&
            caseListResponse?.data?.resultSets && caseListResponse?.data?.resultSets.length > 0) {
            const tableData = ['id','unique_id', 'dealer_name', 'customer_name', 'loan_type', 'vehicle_registration_number', 'bank_name', 'loan_required_amount', 'status','created_at' ,'created_user_name'];
            const data = caseListResponse?.data?.resultSets.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        key === 'unique_id' ? {[key]: element['id']} : {[key]: element[key]}
                    )),
                    (element['status'] && (element['status'].toLocaleLowerCase() === 'payment rejected' || element['status'].toLocaleUpperCase() === 'DISBURSED' ||
                        element['status'].toLocaleUpperCase() === 'LOGGED_IN' ||
                        element['status'].toLocaleUpperCase() === 'APPROVED' || element['status'].toLocaleUpperCase() === 'REJECTED' || element['status'].toLocaleUpperCase() === 'CANCELLED')
                    || element['status'] === 'Request For Approval' || element['status'] === 'REQUEST_FOR_CASE_APPROVAL' || element['status'] === 'COMPLETE_PAYMENT_RELEASED' || element['status'] === 'PARTIAL_PAYMENT_RELEASED'
            || element['status'] === 'REQUEST_FOR_PAYMENT_RELEASE_APPROVED' || element['status'] === 'PAYMENT_DETAILS_ADDED' || element['status'] === 'REQUEST_FOR_PAYMENT_RELEASE' ||
                        element['status'] === 'REQUEST_FOR_CASE_MODIFICATION') ?
                    {
                        Action: [
                            { name: 'View Details', link: `${baseUrl}/ucd/case-view`},
                            (parseInt(roleId) === 54) ?  { name: 'Comm Payout Details', link: `${baseUrl}/ucd/payout-details`} :"",
                            (element['status'].toLocaleLowerCase() === 'logged_in' || element['status'].toLocaleLowerCase() === 'logged in')
                                ? {name: 'Edit', link: `${baseUrl}/ucd/case-edit/${match?.params?.id}`} : "",
                            // { name: 'Payment Raise', link: `${baseUrl}/ucd/case/payment-raise`},
                            (parseInt(roleId) === 41 && (element['status'] === 'APPROVED' || element['status'] === 'REQUEST_FOR_PAYMENT_MODIFICATION' || element['status'] === 'PAYMENT_DETAILS_ADDED'))
                                ? { name: 'Payment Raise', link: `${baseUrl}/ucd/case/payment-raise-v2/${match?.params?.dealer_id}`} : "",
                            ((element['status'] === 'REQUEST_FOR_CASE_APPROVAL' && (parseInt(roleId) === 54 || parseInt(roleId) === 55))) ? {name: 'PennyDrop', link: `${baseUrl}/ucd/case/account-penny-drop`} : "",
                            (((element['status'].toLocaleLowerCase() !== 'logged_in' || element['status'].toLocaleLowerCase() !== 'logged in')
                                && (parseInt(roleId) === 54 || parseInt(roleId) === 41))) ? {name: 'Tranches to Release Request', link: `${baseUrl}/ucd/case/loan-tranche-release-request`} : "",

                            // { name: 'Payment Release Request', link: `${baseUrl}/ucd/case/payment-raise-view`},
                        ]
                    }
                    //REQUEST_FOR_PAYMENT_RELEASE_APPROVED, PAYMENT_DETAILS_ADDED
                    : (element['status'].toLocaleUpperCase() === 'APPROVED') &&
                        {
                            Action: [
                                parseInt(roleId) === 54 ? { name: 'Change Status', link: `${baseUrl}/ucd/case-view`} : "",
                                //
                                //  parseInt(roleId) === 54 ? {name: 'Change Status', link: "#"} : ""
                            ]
                        },
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(caseListResponse?.data?.total / caseListResponse?.data?.per_page));
        }
    }, [caseListResponse])


    const applyFilter = async (filterData) => {
        setIsLoading(true);
        localStorage.setItem('filterData', JSON.stringify(filterData));
        setFilterData(filterData);
        await caseListRequest(match?.params?.dealer_id,1,'','',filterData);
        setIsLoading(false);
        filterToggle();
    };

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const headerBtns = () => {
        return (
            <>
                <Fragment>
                    <Button
                        onClick={filterToggle}
                        className="filter-hamburger btn btn-transparent"
                    >
                        <img src={Images?.Filter} alt=""></img>
                        {localization.showFilters}
                    </Button>

                    <Link
                        to={`${baseUrl}/ucd/case-add/B2B/${match?.params?.id}`}
                        className="btn btn-primary d-md-inline-block"
                    >
                        {"Add Case"}
                        <img src={Images?.ArrowRight} alt="" />
                    </Link>
                </Fragment>
            </>
        );
    }


    useEffect(() => {
        if (parseInt(caseStatusUpdateResponse?.status) === 200) {
            toast.success(caseStatusUpdateResponse?.message);
            setChangeCarLoanStatusModalOpen(false)
            setTimeout(()  => {
                window.location.reload();
            }, 1000)
        } else if (
            caseStatusUpdateResponse?.status !== 200
        ) {
            toast.error(caseStatusUpdateResponse?.message);
        }
    }, [caseStatusUpdateResponse]);

    return (
        <>
            <Layout
                title={"Case Listing"}
                isLoading={isLoading}
                isGoback={true}
                Buttons={headerBtns}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={caseListResponse?.data?.resultSets}
                    srNo={caseListResponse?.data?.from}
                    setChangeCarLoanStatusModalOpen={setChangeCarLoanStatusModalOpen}
                    carLoanId={setId}
                />
                <ListFilters
                    showFilter={showFilter}
                    filterToggle={filterToggle}
                    applyFilter={(val) => applyFilter(val)}
                    ucdCasesFilter
                />
                {/*<UcdCasesFilters*/}
                {/*    showFilter={showFilter}*/}
                {/*    filterToggle={filterToggle}*/}
                {/*    applyFilter={(val) => applyFilter(val)}*/}
                {/*    rmTicketFilter*/}
                {/*    carModelRequest={carModelRequest}*/}
                {/*    carVariantRequest={carVariantRequest}*/}
                {/*    carBrandResponse={carBrandResponse}*/}
                {/*    carModelResponse={carModelResponse}*/}
                {/*    carVariantResponse={carVariantResponse}*/}
                {/*/>*/}
            </Layout>

            {/*<ModalPop*/}
            {/*    title={"Change Status"}*/}
            {/*    show={changeCarLoanStatusModalOpen}*/}
            {/*    handleModalHide={() => {*/}
            {/*        setChangeCarLoanStatusModalOpen(false)*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <Fragment>*/}
            {/*        <FormSection>*/}
            {/*            <div className={s.root}>*/}
            {/*                <div  className={s.root}>*/}
            {/*                    <div>*/}
            {/*                        <div className="col-sm-12 col-ms-12 ">*/}
            {/*                            <DropDownInput*/}
            {/*                                label={'Status'}*/}
            {/*                                data={[{id: 4, name: "Disburse"}]}*/}
            {/*                                value={""}*/}
            {/*                                isStarRequired={true}*/}
            {/*                                getIdValue={(val) => {*/}
            {/*                                    setStatusChangeInput({ ...statusChangeInput, status: val.id })*/}
            {/*                                }}*/}
            {/*                                required={true}*/}
            {/*                            />*/}
            {/*                        </div>*/}

            {/*                        <div className="col-sm-12 col-ms-12 ">*/}
            {/*                            <ConstantInput*/}
            {/*                                label={localization.remark}*/}
            {/*                                type="text"*/}
            {/*                                value={""}*/}
            {/*                                required={true}*/}
            {/*                                className="my-custom-datepicker-component "*/}
            {/*                                handleChange={(val) =>*/}
            {/*                                    setStatusChangeInput({ ...statusChangeInput, remark: val })*/}
            {/*                                }*/}
            {/*                            />*/}
            {/*                        </div>*/}

            {/*                        <br />*/}
            {/*                        <div className="confirm-button" style={{marginBottom:"15px"}}>*/}
            {/*                            <div className='col-md-6 col-sm-6'>*/}
            {/*                                <div className={s.button} style={{width:"36%"}}>*/}
            {/*                                    <Button onClick={() => submitStatus()}>{'Final Submit'}</Button>*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </FormSection>*/}
            {/*    </Fragment>*/}
            {/*</ModalPop>*/}
        </>
    )
}

export default CaseListing
